import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
//primeReact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
//components
import Input from "../../../../components/input/Input";
import Select from "../../../../components/input/Select";
import TextareaInput from "../../../../components/input/TextareaInput";
//services
import Modal from "../../../../components/modal/Modal";
import NumberInput from "../../../../components/input/NumberInput";
import { onSubmitEditLand } from "../../../../services/Register/EditLand";
// import FileInput from "../../../../components/input/FileInput";
//context
import { useAppContext } from "../../../../context/AppContext";

const ModalEditLands = ({
  visible,
  handleCloseModal,
  rowData,
  land = "",
  setVisible,
  loading,
  // setFileSelected,
  investor,
  lands,
  setLands,
}) => {
  const { nomenclatures } = useAppContext();
  //  // console.log(rowData);
  const nomenclature = JSON.parse(nomenclatures);

  const {
    control: controlEditLand,
    handleSubmit: handleEditLand,
    reset: resetEditLand,
    formState: { errorsEditLand },
    setValue,
  } = useForm();

  const [setLoadingLand] = useState(false);

  async function sendEditLand(data) {
    // console.log(data);
    const updatedLands = [...lands];
    // console.log(updatedLands);
    try {
      handleCloseModal();
      await onSubmitEditLand(
        data,
        resetEditLand,
        setLoadingLand,
        errorsEditLand,
        setVisible
      );
      const updatedIndex = updatedLands.findIndex(
        (item) => item.id === data.id
      );
      // console.log(updatedIndex);
      if (updatedIndex !== -1) {
        updatedLands[updatedIndex].metro = data.m2;
        updatedLands[updatedIndex].investor_id = data.investor_id;
        updatedLands[updatedIndex].m2 = data.m2;
        updatedLands[updatedIndex].block_id = data.block_id;
        updatedLands[updatedIndex].land = data.name;
        updatedLands[updatedIndex].name = data.name;
        updatedLands[updatedIndex].value = data.value;
        updatedLands[updatedIndex].num_register = data.num_register;
        updatedLands[updatedIndex].city_hall_register = data.city_hall_register;
        updatedLands[updatedIndex].address = data.address;
        updatedLands[updatedIndex].front_measurement = data.front_measurement;
        updatedLands[updatedIndex].bottom_measurement = data.bottom_measurement;
        updatedLands[updatedIndex].right_measurement = data.right_measurement;
        updatedLands[updatedIndex].left_measurement = data.left_measurement;
        updatedLands[updatedIndex].corner_measurement = data.corner_measurement;
        updatedLands[updatedIndex].front_confrontation =
          data.front_confrontation;
        updatedLands[updatedIndex].bottom_confrontation =
          data.bottom_confrontation;
        updatedLands[updatedIndex].right_confrontation =
          data.right_confrontation;
        updatedLands[updatedIndex].left_confrontation = data.left_confrontation;
        updatedLands[updatedIndex].others_confrontation =
          data.others_confrontation;
        updatedLands[updatedIndex].descriptive_memorial =
          data.descriptive_memorial;
        updatedLands[updatedIndex].obs = data.obs;
      }
      // console.log(updatedLands)

      setLands(updatedLands);
    } catch (error) {
      //      console.log(error);
    }
  }

  useEffect(() => {
    if (typeof rowData === "object") {
      // console.log(rowData);
      // console.log(land);
      setValue("id", rowData.id);
      setValue("m2", rowData.metro ? rowData.metro : rowData.m2);
      setValue("investor_id", rowData.investor_id ? rowData.investor_id : rowData.investor_id);
      setValue("name", rowData.land ? rowData.land : rowData.name);
      setValue("value", rowData.value);
      setValue("status", rowData.status);
      setValue(
        "num_register",
        rowData.num_register ? rowData.num_register : ""
      );
      setValue(
        "city_hall_register",
        rowData.city_hall_register ? rowData.city_hall_register : ""
      );
      setValue("address", rowData.address ? rowData.address : "");
      setValue(
        "front_measurement",
        rowData.front_measurement ? rowData.front_measurement : ""
      );
      setValue(
        "bottom_measurement",
        rowData.bottom_measurement ? rowData.bottom_measurement : ""
      );
      setValue(
        "right_measurement",
        rowData.right_measurement ? rowData.right_measurement : ""
      );
      setValue(
        "left_measurement",
        rowData.left_measurement ? rowData.left_measurement : ""
      );
      setValue(
        "corner_measurement",
        rowData.corner_measurement ? rowData.corner_measurement : ""
      );
      setValue(
        "front_confrontation",
        rowData.front_confrontation ? rowData.front_confrontation : ""
      );
      setValue(
        "bottom_confrontation",
        rowData.bottom_confrontation ? rowData.bottom_confrontation : ""
      );
      setValue(
        "right_confrontation",
        rowData.right_confrontation ? rowData.right_confrontation : ""
      );
      setValue(
        "left_confrontation",
        rowData.left_confrontation ? rowData.left_confrontation : ""
      );
      setValue(
        "others_confrontation",
        rowData.others_confrontation ? rowData.others_confrontation : ""
      );
      setValue(
        "descriptive_memorial",
        rowData.descriptive_memorial ? rowData.descriptive_memorial : ""
      );
      setValue("obs", rowData.obs ? rowData.obs : "");
      setValue(
        "block_id",
        rowData.block && rowData.block.id
          ? rowData.block.id
          : rowData.block_id && rowData.block_id
      );
    }
  }, [rowData]);

  return (
    <>
      <Modal
        visible={visible}
        position="center"
        onHide={handleCloseModal}
        dynamicTitle={`Editar ${nomenclature[0].value} - ${land && land.block && land.block
          } / ${nomenclature[1].value} - ${land.land && land.land} `}
      >
        {loading ? (
          <div className="row d-flex">
            {Array.from({ length: 16 }).map((_, i) => (
              <div key={i} className="col-md-6 mt-2 form-group">
                <span className="p-float-label mt-3">
                  <Skeleton width="100%" height="50px"></Skeleton>
                </span>
              </div>
            ))}
          </div>
        ) : (
          <form onSubmit={handleEditLand(sendEditLand)}>
            <div className="row d-flex">
              <Input
                className="d-none"
                defaultValue={rowData.block?.id}
                name="block_id"
                control={controlEditLand}
                errors={errorsEditLand}
                label=""
              />
              <Input
                className="d-none"
                name="id"
                defaultValue={rowData.id}
                control={controlEditLand}
                errors={errorsEditLand}
                label=""
              />
              <Input
                className="d-none"
                name="status"
                defaultValue={rowData.status}
                control={controlEditLand}
                errors={errorsEditLand}
                label=""
              />

              <div className="col-md-6 mt-2 form-group">
                <span className="p-float-label mt-3">
                  <Select
                    name="investor_id"
                    errors={errorsEditLand}
                    control={controlEditLand}
                    options={investor}
                    label="Investidor"
                    style={{ marginTop: "1.5rem" }}
                  />
                </span>
              </div>

              <div className="col-md-6  form-group">
                <Input
                  name="name"
                  control={controlEditLand}
                  label={nomenclature[1].value}
                  errors={errorsEditLand}
                />
              </div>
              <div className="col-md-6 mb-2 mt-2 form-group">
                <Input
                  name="m2"
                  control={controlEditLand}
                  label="M²"
                  errors={errorsEditLand}
                />
              </div>
              <div className="col-md-6 mb-2 mt-2">
                <NumberInput
                  name="value"
                  mode="currency"
                  currency="BRL"
                  locale="pt-BR"
                  useGrouping={true}
                  control={controlEditLand}
                  label="Valor"
                  errors={errorsEditLand}
                />
              </div>
              <div className="col-md-6 mb-2 mt-4 form-group">
                <span className="p-float-label">
                  <Input
                    name="num_register"
                    control={controlEditLand}
                    label="Matrícula"
                    errors={errorsEditLand}
                  />
                </span>
              </div>
              <div className="col-md-6 mb-2 mt-4 form-group">
                <span className="p-float-label">
                  <Input
                    name="city_hall_register"
                    control={controlEditLand}
                    label="Cadastro na Prefeitura"
                    errors={errorsEditLand}
                  />
                </span>
              </div>
              <div className="col-md-6 mb-2 mt-4 form-group">
                <span className="p-float-label">
                  <Input
                    name="address"
                    control={controlEditLand}
                    label="Endereço"
                    errors={errorsEditLand}
                  />
                </span>
              </div>
              <div className="col-md-6 mb-2 mt-4 form-group">
                <span className="p-float-label">
                  <Input
                    name="front_measurement"
                    control={controlEditLand}
                    label="Metragem da Frente"
                    errors={errorsEditLand}
                  />
                </span>
              </div>
              <div className="col-md-6 mb-2 mt-4 form-group">
                <span className="p-float-label">
                  <Input
                    name="bottom_measurement"
                    control={controlEditLand}
                    label="Metragem do Fundo"
                    errors={errorsEditLand}
                  />
                </span>
              </div>
              <div className="col-md-6 mb-2 mt-4 form-group">
                <span className="p-float-label">
                  <Input
                    name="right_measurement"
                    control={controlEditLand}
                    label="Metragem do Lado Direito"
                    errors={errorsEditLand}
                  />
                </span>
              </div>
              <div className="col-md-6 mb-2 mt-4 form-group">
                <span className="p-float-label">
                  <Input
                    name="left_measurement"
                    control={controlEditLand}
                    label="Metragem do Lado Esquerdo"
                    errors={errorsEditLand}
                  />
                </span>
              </div>
              <div className="col-md-6 mb-2 mt-4 form-group">
                <span className="p-float-label">
                  <Input
                    name="corner_measurement"
                    control={controlEditLand}
                    label="Metragem da Esquina"
                    errors={errorsEditLand}
                  />
                </span>
              </div>
              <div className="col-md-6 mb-2 mt-4 form-group">
                <span className="p-float-label">
                  <Input
                    name="front_confrontation"
                    control={controlEditLand}
                    label="Confrontação da Frente"
                    errors={errorsEditLand}
                  />
                </span>
              </div>

              <div className="col-md-6 mb-2 mt-4 form-group">
                <span className="p-float-label">
                  <Input
                    name="bottom_confrontation"
                    control={controlEditLand}
                    label="Confrontação do Fundo"
                    errors={errorsEditLand}
                  />
                </span>
              </div>

              <div className="col-md-6 mb-2 mt-4 form-group">
                <span className="p-float-label">
                  <Input
                    name="right_confrontation"
                    control={controlEditLand}
                    label="Confrontação do Lado Direito"
                    errors={errorsEditLand}
                  />
                </span>
              </div>

              <div className="col-md-6 mb-2 mt-4 form-group">
                <span className="p-float-label">
                  <Input
                    name="left_confrontation"
                    control={controlEditLand}
                    label="Confrontação do Lado Esquerdo"
                    errors={errorsEditLand}
                  />
                </span>
              </div>

              <div className="col-md-12 mb-4 pb-2  mt-4 form-group">
                <span className="p-float-label">
                  <Input
                    name="others_confrontation"
                    value={rowData.others_confrontation}
                    control={controlEditLand}
                    label="Outras confrontações"
                    errors={errorsEditLand}
                  />
                </span>
              </div>

              <div className="col-md-12 mb-4 form-group">
                <TextareaInput
                  name="descriptive_memorial"
                  control={controlEditLand}
                  className="w-100"
                  label={`Memorial do ${nomenclature[1].value}`}
                  errors={errorsEditLand}
                />
              </div>

              <div className="col-md-12 mb-2 form-group">
                <TextareaInput
                  name="obs"
                  control={controlEditLand}
                  className="w-100"
                  label="Observação"
                  errors={errorsEditLand}
                />
              </div>
              {/* <div className="col-md-12 form-group mb-3">
              <FileInput
                doc={`Imagem do ${nomenclature[1].value}`}
                icon="fa-image"
                setSelectedFile={setFileSelected}
              />
            </div> */}
              <div className="text-center pt-4">
                <Button
                  rounded
                  label="Alterar"
                  type="submit"
                  icon="fa fa-solid fa-pen-to-square"
                  className="p-inputtext-sm m-auto"
                />
              </div>
            </div>
          </form>
        )}
      </Modal>
    </>
  );
};

export default ModalEditLands;
